import type { ModuleFile } from '../../core/modules.ts';

// Módulo «calendar»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'calendar',
    title: 'Calendario',
    path: 'calendario',
    nav: { group: 'Trabajo', label: 'Calendario', icon: '▦', order: 3 },
    load: () => import('./CalendarPage.tsx').then((m) => ({ default: m.CalendarPage })),
  },
];
